/*******************************************************************************
 * Copyright     : Copyright (c)  2021 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : Home.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Home Page component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : December 16, 2021
 *
 * @Version      : Version 1.0
 *
 *
 ******************************************************************************/

import React, { FC, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCustomer } from "stores/CustomerStore";
import {
  selectApmFilesHistory,
  fetchApmFilesHistory,
} from "stores/ApmFilesHistoryStore";
import { AccountModal } from "components/AccountModal";
import { ApmFilesTable } from "components/ApmFilesHistoryTable";
import { NoApmFileHistory } from "components/NoApmFileHistory";
import { Grid } from "@scuf/common";
import {
  selectErrorNotification,
  selectShowAccountModal,
} from "stores/UIStore";
import { NoCustomerAccountSelected } from "components/NoCustomerAccountSelected";
import { resetGeneralInfoForm } from "stores/GeneralInfoStore";
import { resetSelectedApmFile } from "stores/SelectApmFileStore";
import { resetSelectedAircraftDetails } from "stores/AircraftDetailsStore";
import { resetAPMSettingsStore } from "stores/ApmSettingsStore";
import {
  resetSelectedApmRecord,
  setCurrentWorkFlowStep,
  setCurrentWorkFlowType,
} from "stores/ApmWorkFlowStore";
import { EnumApmSettingsWorkFlow } from "models/configuration";

export const Home: FC = () => {
  const selectedCustomer = useSelector(selectCustomer);
  const showAccountModal = useSelector(selectShowAccountModal);
  const { data, loading } = useSelector(selectApmFilesHistory);
  const { error } = useSelector(selectErrorNotification);
  const dispatch = useDispatch();

  const resetStoreValues = useCallback(() => {
    dispatch(resetGeneralInfoForm());
    dispatch(resetSelectedApmFile());
    dispatch(resetSelectedAircraftDetails());
    dispatch(resetAPMSettingsStore());
    dispatch(resetSelectedApmRecord());
    dispatch(setCurrentWorkFlowStep(0));
    dispatch(setCurrentWorkFlowType(EnumApmSettingsWorkFlow.History));
  }, [dispatch]);

  useEffect(() => {
    if (selectedCustomer !== null) {
      dispatch(fetchApmFilesHistory());
    }
    resetStoreValues();
  }, [selectedCustomer, dispatch, resetStoreValues]);

  return (
    <>
      <Grid>
        <Grid.Row>
          <Grid.Column>
            {selectedCustomer === null ? (
              <NoCustomerAccountSelected />
            ) : loading === false && error === null && data.length === 0 ? (
              <NoApmFileHistory />
            ) : (
              <ApmFilesTable data={data} loading={loading} />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {showAccountModal && <AccountModal />}
    </>
  );
};
